import ctl from '@netlify/classnames-template-literals';

export const companyDetailsContainer = ctl(`
    border-[1px]
    border-azureish-white
    shadow-cetacean-blue
    overflow-hidden
    rounded-md  
    mt-3
  `);

export const companyDetailsContainerTitle = ctl(`
    border-b-[1px] 
    bg-ghost-white 
    border-azureish-white 
    font-[600]
    p-2
    flex
    justify-between
   `);

export const form = ctl(`
p-4 
bg-white
grid 
grid-cols-3 
gap-4
`);

export const buttonStyle = ctl(`
  px-8
  py-2
  mt-4
  rounded-xl
  bg-green-ncs
  text-anti-flash-white
  cursor-pointer
`);

export const buttonsContainer = ctl(`
grid 
grid-cols-2
mb-4
`);

export const saveCancelButtonsContainer = ctl(`
mb-4
grid 
grid-cols-2 
gap-10
`);

export const cancelButtonStyle = ctl(`
px-8
py-2
mt-4
rounded-xl
bg-white
cursor-pointer
`);

export const deleteButton = 'text - slate - 200 px - 4 hover:bg-indigo-600';
